import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m11.135 16.567-2.629.033-.592-2.507c-.083-.353 0-.723.228-1.008l6.805-8.51a1.62 1.62 0 0 1 2.25-.22l1.253.973c.75.454.984 1.42.52 2.156-.007.011-.588.74-1.41 1.769m-3.883-3.085 3.938 3.025-.055.06m0 0-.381.477"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      d: "M4.197 6.7s1.965.768 2.7 1.8c1.823 2.56-5.424 4.64-3.6 7.2.735 1.033 2.7 1.8 2.7 1.8"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M16 10.5a5 5 0 1 1 0 10 5 5 0 0 1 0-10",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m18.162 14.059-2.883 2.883-1.441-1.442"
    }, null, -1)
  ]))]))
}
export default { render: render }